import PageTitle from '../../components/pagetitle/PageTitle'

import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'

import simag from '../../images/service/a.jpg'
import Gimg1 from '../../images/cta-bg.jpg'
import Gimg2 from '../../images/cta-2.jpg'
import Gimg3 from '../../images/cta-2.jpg'
import Gimg4 from '../../images/cta-4.jpg'


const AirFreight = ({ serviceDetails }) => {
    return (
        <>
            <section className={`wpo-breadcumb-area ${serviceDetails.slug}`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            </section>
            <section id='details' className='wpo-service-single-page section-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2 className='mt-0'>{serviceDetails.title}</h2>
                                <div className="title-image">
                                    <img src={simag} alt="" />
                                </div>

                                <p>
                                    Given air freight’s sensitivity and time pressures, Our International Logistics develops comprehensive air freight service plans tailored to our customers’ specific requirements. By clearly understanding each customer’s exact objectives, we effectively manage the extreme time constraints and critical deadlines associated with sensitive and high-value goods.
                                    Our Air Freight Department designs customized service plans for every client and implements the necessary Operational Handling Procedures to ensure consistent, high-quality service. Our experienced air freight professionals oversee each shipment from start to finish, providing real-time status updates for all import and export air freight movements.

                                    For oversized cargo transportation, we offer specialized expertise in both part and full charter services, including complete door-to-door delivery solutions on a global scale.
                                </p>

                                <div className="fc-gray my-4 pb-5">
                                    <h5>Our Air Freight Services offer end-to-end logistics solutions, including pickup, professional packing, assembly, secure warehousing, complete documentation, and efficient cargo handling:-</h5>
                                    <ul className="list-unstyled mt-3 fs-6">
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Fashion & Luxury Goods
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Auto and Automotive Part
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pharmaceutical Cargo
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Precious Metal Cargo
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Import/Export
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pick, Pack, Assembly and Distribution
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Split and Full Air Charter
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Worldwide Door-to-Door Services
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Sea/Air & Road/Air Service
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Customs Clearance Service
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pick-up and Delivery Service
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Packing and Crating
                                        </li>
                                    </ul>
                                </div>


                                <h3 className="quate">
                                    Air freight delivers fast, secure, and time-critical transportation solutions, connecting global markets while ensuring efficient movement of high-value and urgent cargo.
                                </h3>

                                <div className="image-gallery">
                                    <h2>Eligibility checklist :</h2>
                                    <ul>
                                        <li><img src={Gimg1} alt="" /></li>
                                        <li><img src={Gimg2} alt="" /></li>
                                        <li><img src={Gimg3} alt="" /></li>
                                        <li><img src={Gimg4} alt="" /></li>
                                    </ul>
                                </div>
                                <Accordion />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AirFreight